import react, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { selectReportsResults } from '../../store/features/transmissionSlice';
import FailureReportTable from './FailureReportTable';

const ErrorsTable = () => {
    const [failReportVisibleColumns, setFailReportVisibleColumns] = useState<string[]>([]);
    const reportResults = useSelector(selectReportsResults);
    const failReportColumns = reportResults?.fail_report?.[0] || [];
    const [title, setTitle] = useState('')
    const [subtitle, setSubtitle] = useState('')

    useEffect(() => {
        if (reportResults?.fail_report) {
            const excludedColumns = ['operator', 'index', 'type', 'tag', 'units'];

            if (reportResults?.fail_report.length > 1) {
                setTitle(reportResults?.fail_report[1][3])
                setSubtitle(reportResults?.fail_report[1][4])
            }

            const visibleColumnIds = failReportColumns
                .map((column: any, colIndex: number) => ({
                    id: `fail_report_${colIndex}`,
                    label: column
                }))
                .filter((col: any) => !excludedColumns.some(excluded =>
                    col.label.toLowerCase().includes(excluded.toLowerCase())
                ))
                .map((col: any) => col.id);

            setFailReportVisibleColumns(visibleColumnIds);
        }
    }, [reportResults]);

    if (reportResults === 'No failure in this test report.')
        return (
            <Box sx={{ flex: 1, width: '70vw', mb: 1 }}>
                <Typography 
                    variant="h6" 
                    component="div" 
                    sx={{ 
                        color: '#4caf50',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        padding: '24px',
                    }}
                >
                    ✅ No Major or Significant Failure in this Report
                </Typography>
            </Box>
        )

    if (reportResults.fail_report)
        return <FailureReportTable
            columns={reportResults.fail_report[0].map((column: any, colIndex: number) => ({
                id: `fail_report_${colIndex}`,
                label: column,
                minWidth: 100,
                align: 'left'
            }))}
            data={reportResults.fail_report.slice(1)}
            title={title}
            subtitle={subtitle}
            visibleColumns={failReportVisibleColumns}
            onVisibleColumnsChange={setFailReportVisibleColumns}
        />
    return <></>
}

export default ErrorsTable;
